import { JSX } from "react";
import { useTranslation } from "react-i18next";

import MovieCard from "@/components/cards/MovieCard";
import Carousel from "@/components/helpers/Carousel.tsx";
import Section from "@/components/helpers/Section/Section.tsx";

import { Content } from "@/@types/general.ts";
import { ROUTES } from "@/config/routes.ts";
import { useGetPremiers } from "@/hooks/api/content.hooks.ts";
import { isMobile } from "@/utils/constatns";

const MainPremiersSection = (): JSX.Element => {
  const { t } = useTranslation();
  const { data: premiers } = useGetPremiers(18);

  return (
    <Section title={t("premiere")} link={ROUTES.MAIN.PREMIERE} className={`group/section`}>
      <Carousel<Content>
        swiperParams={{
          slidesPerView: 2,
          spaceBetween: 16,
          followFinger: isMobile,
          breakpoints: {
            576: { slidesPerView: 3, slidesPerGroup: 3 },
            992: { slidesPerView: 4, slidesPerGroup: 4 },
            1200: { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 12 },
            1400: { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 16 },
          },
        }}
        items={premiers.pages[0].results}
        swiperName={"premiers"}
      >
        {(content) => <MovieCard key={content.id} {...content} />}
      </Carousel>
    </Section>
  );
};

export default MainPremiersSection;
